var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListHeader',[_c('div',{staticClass:"flex -mx-4"},[_c('div',{staticClass:"w-24 px-4"}),_c('div',{staticClass:"flex-1 px-4"},[_vm._v("Name")]),_c('div',{staticClass:"w-24 px-4 text-right"},[_vm._v("Cost")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }